import React, { createContext, useContext, useState } from 'react'

const UserNamesContext = createContext()

const useUserNames = () => {
  return useContext(UserNamesContext)
}

const UserNamesProvider = ({ children }) => {
  const [userNames, setUserNames] = useState({})

  const setAlias = (userToken, alias) => {
    setUserNames(userNames => ({
      ...userNames,
      [userToken]: alias,
    }))
  }

  const getAlias = (userToken) => {
    return userNames[userToken] || userToken
  }

  return (
    <UserNamesContext.Provider value={{ setAlias, getAlias }}>
      {children}
    </UserNamesContext.Provider>
  )
}

export { useUserNames, UserNamesProvider }
